module.exports = __webpack_public_path__ + "media/images/badges/rumble/milestone-250-Inactive-Rumble-81ea8881c358d2cee27be45081067423.png";